import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-slate-50 z-[9999]">
      <img 
        src="/specard-logo.png" 
        alt="Specard" 
        className="h-16 w-auto animate-pulse"
      />
    </div>
  );
};

export default LoadingSpinner;
